import styled from "styled-components";

import { TooltipLabel } from "../../react-sgis/symbols/labelSymbols/styled";

export const Label = styled(TooltipLabel)`
  position: absolute;
  z-index: 9999;
  cursor: default;
`;
